var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlotGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91667 4H9.58333V6.66667L22.9167 6.66667V4H25.5833V6.66667L28.25 6.66667V9.33333H25.5833V22.6667H28.25V25.3333H25.5833V28H22.9167V25.3333L9.58333 25.3333V28H6.91667V25.3333H4.25V22.6667H6.91667V9.33333H4.25V6.66667L6.91667 6.66667V4ZM9.58333 22.6667V9.33333H22.9167V22.6667L9.58333 22.6667Z",
    fill: "#696F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5833 8.66667V8H16.9167V8.66667H15.5833ZM15.5833 11.3333V10H16.9167V11.3333H15.5833ZM15.5833 14V12.6667H16.9167V14H15.5833ZM15.5833 16.6667V15.3333H16.9167V16.6667H15.5833ZM15.5833 19.3333V18H16.9167V19.3333H15.5833ZM15.5833 22V20.6667H16.9167V22H15.5833ZM15.5833 24V23.3333H16.9167V24H15.5833Z",
    fill: "#696F88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5833 15.3333H24.25V16.6667H23.5833V15.3333ZM20.9167 15.3333H22.25V16.6667H20.9167V15.3333ZM18.25 15.3333H19.5833V16.6667H18.25V15.3333ZM15.5833 15.3333H16.9167V16.6667H15.5833V15.3333ZM12.9167 15.3333H14.25V16.6667H12.9167V15.3333ZM10.25 15.3333H11.5833V16.6667H10.25V15.3333ZM8.25 15.3333H8.91667V16.6667H8.25V15.3333Z",
    fill: "#696F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlotGrey);
export default __webpack_public_path__ + "static/media/plot-grey.7b6f06ad9ebe1a5b3f6a7b1aaa454572.svg";
export { ForwardRef as ReactComponent };